import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {
        numeroDocumento: "",
        nombres: "",
        empresa: "",
        idTipoPersona: 0,
    },
    results: [],
};

export const personSearchSlice = createSlice({
    name: "personSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;
            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
        resetFilters: (state) => {
            state.filters = { ...initialState.filters };
            state.results = [];
        },
    },
});

export const { setValue, setResults, resetFilters } = personSearchSlice.actions;
export default personSearchSlice.reducer;
